export class KpiData {
	public Id: number;
	public KpiId: number;
	public Period: string;
	public Qty: number;
	public QtyRef: number;
	public QtyMin: number;
	public QtyMax: number;
	public ArrowDirection: number;
}
